import { SectionCSS } from './SectionCSS.styled'

export const Section = ({ title, children, noWrapper = false }) => {
  if (noWrapper) return <SectionCSS noWrapper>{children}</SectionCSS>

  return (
    <SectionCSS>
      <div className='row subtitle'>{title}</div>
      <div className='row'>{children}</div>
    </SectionCSS>
  )
}
